// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__4aN-k","errorLogs":"EditorFooter_errorLogs__3fhwA"};